const filterListActionModalFilter = {
  filter: 'FILTROS',
  clearFilter: 'limpar filtros'
};

export default filterListActionModalFilter;
